import { render, staticRenderFns } from "./workflow-assigned-users.vue?vue&type=template&id=5b215609&"
import script from "./workflow-assigned-users.vue?vue&type=script&lang=js&"
export * from "./workflow-assigned-users.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports